import React from 'react';

import { Box, BoxProps } from '@mui/material';

import './Loader.css';
import { Container } from './styled';

interface ILoader extends Omit<BoxProps, 'ref'> {
  size?: number;
  border?: string;
  children?: React.ReactNode;
  variant?: 'absolute-center';
}

const styles = {
  'absolute-center': {
    position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
  },
}

export const Loader = React.forwardRef<HTMLDivElement, ILoader>(
  function Loader(props, ref) {
    const { variant, sx, size = 48, border = '5px solid #5980FF', ...others } = props;
    return (
      <Container ref={ref} sx={[variant ? styles[variant] : undefined, ...(Array.isArray(sx) ? sx : [sx])]} {...others}>
        <Box
          className="loader"
          sx={{
            width: size,
            height: size,
            '&:before': {
              border,
            },
          }}
        />
      </Container>
    );
  }
);
